// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0_esbuild@0.25.0_/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0_esbuild@0.25.0_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
#    Colors
   ========================================================================== */
/*\$mainColor:#d40621;
\$alphaLight:rgba(#fff, .5);
\$alphaDark:rgba(#000, .5);
\$placeholderTextLight:rgba(#fff, .7);
\$placeholderTextDark:rgba(#000, .7);

\$textLight: #fff;
\$textDark: #404040;
\$textThemes:#d40621;*/
/* ################## */
/* ################## */
/* ################## */
/* ################## */
visiba-signin {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: calc(var(--Z_INDEX_HACK, 0) + 3);
}
@media screen and (max-width: 905px) {
  visiba-signin {
    width: 100vw;
    height: 100vh;
  }
}
visiba-signin .outerWrapper {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
}
visiba-signin .container {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
  overflow-x: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
}
@media screen and (max-width: 905px) {
  visiba-signin .container {
    height: 100%;
    width: 100%;
  }
}
visiba-signin .innerWrapper {
  width: 480px;
  max-width: 90%;
  pointer-events: all;
  cursor: auto;
}
@media screen and (max-width: 905px) {
  visiba-signin .innerWrapper {
    max-width: 100%;
    width: 100%;
    margin: 0 8px;
  }
}
visiba-signin .innerContent {
  position: relative;
  border-radius: 16px;
  background: var(--c_backgroundBox);
  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.5);
  display: flex;
  pointer-events: auto;
  flex-direction: column;
  overflow: hidden;
}
visiba-signin .error {
  text-align: center;
}
visiba-signin .methods {
  text-align: center;
  color: rgba(var(--c_textBody), 0.853659);
}
visiba-signin .methods .list {
  margin-top: 9px;
  background: var(--c_mainColorDark);
  line-height: 1em;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
}
visiba-signin .methods .list-item {
  all: unset;
  color: var(--c_textLight);
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 15px 12px;
  min-width: 100px;
  cursor: pointer;
  flex: 1;
}
visiba-signin .methods .list-item:focus {
  background-color: var(--c_mainColorLight);
}
visiba-signin .methods .list-item.selected {
  background-color: var(--c_mainColorDarkActive);
}
visiba-signin .methods .list-item visiba-svg {
  width: 30px;
}
visiba-signin .methods .list-item visiba-svg .fill {
  fill: var(--c_textLight);
}
visiba-signin .methods .list-item .logInTypeImg {
  height: 40px;
  margin-bottom: 5px;
}
visiba-signin .countrySelect {
  width: 150px;
  margin-left: 20px;
}
visiba-signin .cancel {
  all: unset;
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
  z-index: 1;
}
visiba-signin .cancel visiba-svg {
  width: 20px;
}
visiba-signin .loginReason {
  padding: 40px 40px 0px;
  text-align: center;
}
visiba-signin .loginReason .title {
  font-size: 1.375em;
}
visiba-signin .methodDirectives {
  min-height: 200px;
  text-align: center;
  padding: 40px 40px 16px;
  position: relative;
}
visiba-signin no-auth-login {
  display: block;
  padding: 0 80px;
}
visiba-signin no-auth-login .btn {
  margin: 1em 0;
  background: var(--c_mainColorDark);
  width: 100%;
}
visiba-signin no-auth-login input {
  display: block;
  width: 100%;
  box-sizing: border-box;
}
visiba-signin no-auth-login .error {
  margin: 1em 0;
  color: var(--c_accentColor);
}
visiba-signin sms-login form .codeField {
  padding-top: 10px;
  margin-top: 6px;
}
visiba-signin sms-login form .codeField.nhsStyling {
  padding-top: 0;
  margin-top: 0;
}
visiba-signin sms-login form .codeAgain {
  font-size: 0.875em;
  text-align: center;
  cursor: pointer;
}
visiba-signin sms-login form .codeSent {
  font-size: 0.75em;
  color: var(--c_mainColorDark);
  text-align: center;
}
visiba-signin sms-login form .err {
  font-size: 0.75em;
  color: var(--c_errorText);
}
visiba-signin sms-login form .btn.large {
  margin-top: 30px;
  width: 100%;
}
visiba-signin sms-login form .btn.large.nhsButton {
  height: 80%;
  width: 50%;
}
visiba-signin sms-login .nhsFont {
  font-size: 1rem;
  margin-bottom: 0;
  color: #505050;
}
visiba-signin visibacare-iframe-auth {
  display: block;
  text-align: center;
}
visiba-signin visibacare-iframe-auth visiba-svg {
  width: 40px;
  position: absolute;
  top: 20%;
  left: 50%;
  margin-left: -20px;
  z-index: 2;
}
visiba-signin visibacare-iframe-auth .btn {
  margin-top: 4em;
  padding: 8px 30px;
}
visiba-signin visibacare-iframe-auth .btn-nhs {
  display: inline-flex;
  padding: 10px;
  gap: 16px;
  align-items: center;
  background-color: #005eb8;
  color: #fff;
  line-height: 0;
  border: none;
  border-radius: 5px;
}
visiba-signin visibacare-iframe-auth .loading-nhs {
  display: inline-flex;
  padding: 10px;
  gap: 16px;
  align-items: center;
  color: #005eb8;
  line-height: 0;
  font-weight: 600;
}
visiba-signin .marginBottom2 {
  margin-bottom: 2rem;
}
visiba-signin .marginBottom4 {
  margin-bottom: 4rem;
}

@media only screen and (max-height: 600px) {
  visiba-signin .outerWrapper {
    display: block;
  }
  visiba-signin .outerWrapper .innerWrapper {
    margin: 50px auto;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
